/* eslint-disable sort-keys-fix/sort-keys-fix */
import React from "react";
import { withPage } from "hoc/WithPages";
import SiteTable from "components/SiteTables";

const PrivacyPolicy = () => (
	<div className="">
		<h1 className="text-4xl font-bold mb-4">
			Privacy Policy<span className="text-primary">.</span>
		</h1>
		<div className="mb-48">
			<section>
				<p>
					Dead Easy, a company registered in England and Wales under company
					registration number XXXXXX our registered office XXXXX. is committed
					to protecting and respecting your privacy.
				</p>
				<p>
					This policy (together with our terms and conditions) sets out the
					basis on which any personal data we collect from you, or that you
					provide to us, will be processed by us. Please read the following
					carefully to understand our views and practices regarding your
					personal data and how we will treat it. For the purposes of data
					protection laws in the UK, the data controller is Dead Easy. We are
					registered as a data controller with the Information Commissioner’s
					Office under number XXXX
				</p>
			</section>
			<section>
				<h4>Basis for processing personal data</h4>
				<p>
					Personal data is any information which can (or could be used to)
					identify a living person.
				</p>
				<p>
					The paragraphs in this section explain how and why we process your
					personal data, as well as the legal basis on which we carry out this
					processing. To enter into and perform contracts with you: Where you
					ask us to provide services to you, we will process your personal data
					to provide these services to you. We need certain personal information
					about you to provide the services to you. We may also share your
					information with other Dead Easy companies in order to provide
					services to you. If you do not wish to provide us with your personal
					data in this way, you will be unable to use our services.
				</p>
				<p>
					To provide services to you: We use a number of third party service
					providers to help us provide our services. In order to do this, we may
					have to provide some of your information to them and we will only ever
					do this to the extent necessary to provide services to you and only
					when we have contractual provisions in place to ensure your
					information is securely held and not used for any other purpose.
				</p>
				<p>
					To improve how we provide our services: We analyse personal data to
					identify areas so that we can improve our services and we sometimes
					engage third parties to assist us with this analysis.
				</p>
				<p>Some examples are:</p>
				<ul>
					<li>
						Recording calls to analyse and improve how we provide our services
						over the phone.
					</li>
					<li>
						Analysing feedback you provide on external review platforms, on our
						website chat function or in emails and the way you interact with our
						services.
					</li>
				</ul>
				<p>
					To make our website better: We will also process your personal data in
					order to provide you with a more tailored experience when you visit
					our website. For example, we may use your personal data to tailor our
					website, make sure it is displayed in the most effective way for the
					device you are using. We also use various third party cookies to help
					us improve our website (more details are set out in the sections
					below) but we will not share your personal data with the third party
					analytics and search engine providers that assist us in the
					improvement and optimisation of our website.
				</p>
				<p>
					We will also process your personal data for the purposes of making our
					website more secure, and to administer our website and for internal
					operations, including troubleshooting, data analysis, testing,
					research and statistical and survey purposes.
				</p>
				<p>
					The legal basis on which we process your personal data in these
					circumstances is our legitimate interest to optimise website visitor
					engagement, inform future content and to ensure that our website is
					kept secure. For user research: We have a legitimate interest to
					contact you in relation to your experience of using our products and
					services. We will use any feedback provided to tailor and improve our
					services. We may also conduct research to develop new products and
					services where input from users’ experience would inform our approach.
				</p>
				<p>
					For Dead Easy marketing purposes: We may contact you if your recent
					activity suggests you might want to hear from us (for example, you
					entered one of our promotions, you have used our services or you have
					an annual subscription with us), unless you have already indicated
					that you do not wish to receive marketing communications from us.
				</p>
				<p>
					We process your personal data to form a view on what services,
					promotions or offers we think you may be interested in.
				</p>
				<p>
					Our communications always include a link so you can unsubscribe. You
					can also let us know you would prefer not to be contacted by emailing{" "}
					<a href="mailto:jgadsby@iamtheap.com">jgadsby@iamtheap.com</a> and
					clearly stating that you wish to be removed from our marketing list.
				</p>
				<p>
					To allow charities to communicate with you: We sometimes ask you if
					you are happy to receive marketing communications from the charities
					we work with (for example, they have referred you to our services or
					you have left the charity a gift in your will). If you agree and
					provide your consent, we send the charity your personal data so they
					can contact you directly. Where you change your mind and decide you
					would prefer not to be contacted by the charity, you should let them
					know (their communication should also contain an unsubscribe link).
				</p>
				<p>
					Where you do not receive a prompt to ask you for your consent to share
					your personal data with the charity for their marketing
					communications, this means that Dead Easy have an agreement with the
					charity whereby we provide your personal data to them so they can
					contact you directly (unless you have indicated to us you do not want
					us to share your personal data for this reason).
				</p>
				<p>
					To allow our charity partners to analyse and optimise their legacy
					campaigns and to update their supporter databases: We will share some
					basic information relating to you (name, address, email address, date
					of birth, phone number), gift type and gift amount bracket (if any),
					to allow our charity partners to assess and improve their legacy
					campaigns and update their supporter databases.
				</p>
				<p>
					To enable tracking and attribution of referrals and campaigns from our
					commercial partners: Where you have been referred by one of our
					commercial partners we will share some basic information relating to
					you (name, address, email address, date of birth, phone number) to
					allow our commercial partners to attribute referrals. This will be in
					addition to your communication preferences and this information will
					not be used for marketing purposes if you have not given consent for
					that purpose.
				</p>
				<p>
					To create anonymised data sets: Anonymised data is information which
					cannot be used to identify a living person. It is useful for
					statistical analysis and identifying general trends. We will convert
					your personal data into an anonymised format so it can be used for
					press publication (for instance to show the age range of our
					customers, or geographical areas where we provide a high volume of
					service) and to help charity partners raise money through gifts in
					wills by helping them to evaluate the efficacy of their marketing
					campaigns. Anonymised data is not personal data.
				</p>
				<p>
					For customised marketing content, insight and analysis: We may use
					your personal information to generate aggregated, anonymised data for
					the purposes of internal reporting, customised marketing content,
					insight and analysis. This will enable us to improve and personalise
					our Site, the products we offer and search results for our Site. As
					part of this we use Google Analytics. For further information, see{" "}
					<a
						href="https://policies.google.com/technologies/partner-sites"
						target="_blank"
						rel="noreferrer"
					>
						Google’s Privacy and Terms
					</a>
					.
				</p>
				<p>
					If our business is sold: We will transfer your personal data to a
					third party: In the event that we buy or sell any business or assets,
					in which case we will disclose your personal data to the prospective
					seller or buyer of such business or assets (at all times in accordance
					with all applicable data protection laws); or if Dead Easy or
					substantially all of its assets are acquired by a third party, in
					which case personal data held by Dead Easy about its customers will be
					one of the assets transferred to the purchaser.
				</p>
				<p>
					In each case, the legal basis on which we process your personal data
					in these circumstances is our legitimate interest to ensure our
					business can be continued by a purchaser. If you object to our use of
					your personal data in this way, the relevant seller or buyer of our
					business may not be able to provide services to you.
				</p>
			</section>
			<section>
				<h4>Basis for processing anonymised data</h4>
				<p>
					We process data and share it with charity partners anonymously in
					order to help then raise money through gifts in wills. We share the
					number and size of gifts left to particular charities, as well as
					generalised demographic information, in order to help charity partners
					understand the efficacy of their legacy marketing efforts while
					maintaining your privacy.
				</p>
			</section>
			<section>
				<h4>Information we collect from you</h4>
				<p>We will collect and process the following data about you:</p>
				<ul>
					<li>
						Information you give us. This is information about you that you give
						us by filling in forms on our site or by corresponding with us by
						phone, e-mail or otherwise. It includes information you provide when
						you register to use our Website, place an order for a document
						and/or services on our Website and when you report a problem with
						our Website. The information you give us may include your name,
						address, e-mail address and phone number, financial and credit card
						information and other information related to your assets or relating
						to your involvement in the estate of someone who has died. We do not
						store credit card details nor do we share financial details with any
						third parties.
					</li>
					<li>
						Information we collect about you. With regard to each of your visits
						to our Website we will automatically collect the following
						information:
						<ul>
							<li>
								technical information, including the Internet protocol (IP)
								address used to connect your computer to the Internet, your
								login information, browser type and version, time zone setting,
								browser plug-in types and versions, operating system and
								platform; and
							</li>
							<li>
								information about your visit, including the full Uniform
								Resource Locators (URL), clickstream to, through and from our
								Website (including date and time), products you viewed or
								searched for, page response times, download errors, length of
								visits to certain pages, page interaction information (such as
								scrolling, clicks, and mouse-overs), methods used to browse away
								from the page, and any phone number used to call our customer
								service number.
							</li>
						</ul>
					</li>
				</ul>
			</section>
			<section>
				<h4>Cookies</h4>
				<p>
					Our Website uses cookies to distinguish you from other users of our
					Website. This helps us to provide you with a good experience when you
					browse our Website and also allows us to improve our Website. Please
					see our Cookie Policy for further details.
				</p>
			</section>
			<section>
				<h4>Uses made of the information</h4>
				<p>
					We will combine the information you provide to us with information we
					collect about you. We will use this information and the combined
					information for the purposes set out above (depending on the types of
					information we receive).
				</p>
			</section>
			<section>
				<h4>Who we share your personal data with</h4>
				<ul>
					<li>Our staff: Our staff have access to your personal data.</li>
					<li>
						Charities and businesses we work with: For example the charities we
						work with through our wills service.
					</li>
					<li>
						External parties: That are performing tasks on our behalf (including
						subcontractors and professional advisors).
					</li>
					<li>
						Regulatory authorities: Where we have a legitimate legal reason for
						doing so.
					</li>
					<li>Any actual or potential buyer of our business.</li>
				</ul>
			</section>
			<section>
				<h4>Where we store personal data</h4>
				<p>
					All information you provide to us is stored on secure servers. Where
					we have given you (or where you have chosen) a password which enables
					you to access certain parts of our Website, you are responsible for
					keeping this password confidential. You must not share your password
					with anyone.
				</p>
			</section>
			<section>
				<h4>Period of storage</h4>
				<p>
					We will retain any personal data that you provide and documents that
					you have created using the Document Preparation Service in electronic
					form for as long as is necessary for us to provide the relevant
					service and for our own legal and administrative purposes.
				</p>
				<p>
					Due to the nature of the services and pursuant to Article 17(3) GDPR,
					if you complete a will using our service we will securely store your
					data indefinitely. This is in order to protect against legal claims
					(for example in the case of suspected fraud), as well as to provide
					supporting information if your will is ever contested. Where we have
					processed your personal data to provide you with marketing
					communications with your consent, we may contact you at least every 12
					months to ensure you are happy to continue receiving such
					communications. If you tell us that you no longer wish to receive such
					communications, your personal data will be removed from our list.
				</p>
			</section>
			<section>
				<h4>Your rights under data protection laws</h4>
				<h4>Right to object</h4>
				<p>
					You have the right to object to us processing your personal data where
					we are processing your personal data: based on our legitimate
					interests (as set out above). If you ask us to stop processing your
					personal data on this basis, we will stop processing your personal
					data unless we can demonstrate compelling grounds as to why the
					processing should continue in accordance with data protection laws;
					and for direct marking purposes. If you ask us to stop processing your
					personal data on this basis, we will stop.
				</p>
				<h4>Right to access</h4>
				<p>
					You have the right to receive confirmation as to whether your personal
					data is being processed by us, as well as various other information
					relating to our use of your personal data. You also have the right to
					access your personal data which we are processing.
				</p>
				<h4>Right to rectification</h4>
				<p>
					You have the right to require us to rectify any inaccurate personal
					data we hold about you. You also have the right to have incomplete
					personal data we hold about you completed, by providing a
					supplementary statement to us.
				</p>
				<h4>Right to restriction</h4>
				<p>
					You have the right to restrict our processing of your personal data
					where: the accuracy of the personal data is being contested by you;
					the processing by us of your personal data is unlawful, but you do not
					want the relevant personal data erased; we no longer need to process
					your personal data for the agreed purposes, but you want to preserve
					your personal data for the establishment, exercise or defence of legal
					claims; or we are processing your data on the basis of our legitimate
					interest(as set out above) and you:
				</p>
				<ul>
					<li>object to our processing on this basis; and</li>
					<li>
						want processing of the relevant personal data to be restricted until
						it can be determined whether our legitimate interest overrides your
						legitimate interest.
					</li>
				</ul>
				<p>
					Where any exercise by you of your right to restriction determines that
					our processing of particular personal data is to be restricted, we
					will then only process the relevant personal data in accordance with
					your consent and, in addition, for storage purposes and for the
					purpose of legal claims.
				</p>
				<h4>Right to data portability</h4>
				<p>
					You have the right to receive your personal data in structured,
					standard machine readable format and the right to transmit such
					personal data to another controller.
				</p>
				<h4>Right to erasure</h4>
				<p>
					You have the right to require we erase your personal data which we are
					processing where at least one of the following grounds applies: the
					processing is no longer necessary in relation to the purposes for
					which your personal data were collected or otherwise processed; our
					processing of your personal data is based on your consent, you have
					subsequently withdrawn your consent and there is no other legal ground
					we can use to process your personal data; you object to the processing
					as set out in the “right to object” section of this policy and we have
					no overriding legitimate interest for our processing; the personal
					data have been unlawfully processed; and the erasure is required for
					compliance with a law to which we are subject.
				</p>
				<p>
					If you have any concerns or queries relating to the use of your
					personal data, please let us know in the first instance by contacting
					hello@farewill.com and we would hope to resolve any issue informally.
				</p>
				<p>
					However, if an issue cannot be resolved, you also have the right to
					lodge a complaint with the Information Commissioner’s Office, the
					supervisory authority for data protection issues in England and Wales.
					For further information, please see{" "}
					<a
						href="https://ico.org.uk/make-a-complaint"
						target="_blank"
						rel="noreferrer"
					>
						https://ico.org.uk/make-a-complaint
					</a>
				</p>
				<h4>Exercising your rights</h4>
				<p>
					You can exercise such rights by contacting us at{" "}
					<a href="mailto:pbraham@iamtheap.com">pbraham@iamtheap.com</a> We may
					require confirmation of your identity before acting on a request.
				</p>
			</section>
			<section>
				<h4>Links on our website</h4>
				<p>
					Our website may, from time to time, contain links to and from the
					websites of our partner networks and affiliates. Our service connects
					you to different websites. If you follow a link to any of these
					websites or use our service, please note that you have left our
					website and these websites have their own privacy policies. We do not
					accept any responsibility or liability for these policies or websites.
					Please check these policies before you submit any personal data to
					these websites.
				</p>
			</section>
			<section>
				<h4>Changes to our privacy policy</h4>
				<p>
					Any changes we make to our privacy policy in the future will be posted
					on this page. Please check back frequently to see any updates or
					changes to our privacy policy. We will inform you of any significant
					changes to this policy.
				</p>
			</section>
			<section>
				<h4 className="font-bold text-4xl mt-8">Additional Policies</h4>
				<h4>Modern Slavery Statement</h4>
				<h3>Introduction</h3>
				<p>
					Dead Easy is making a voluntary modern slavery and human trafficking
					statement relating to section 54 of the Modern Slavery Act 2015. It
					sets out our approach for dealing with the potential risk of slavery
					and human trafficking in our business or within our supply chains.
				</p>
				<p>
					We oppose slavery and human trafficking in all its forms and make this
					statement to set out the steps we have taken to ensure that there is
					no slavery or human trafficking in our business or in our supply
					chains.
				</p>
				<h3>1. About us</h3>
				<p>
					Dead Easy is a private limited company incorporated under the laws of
					England and Wales. We provide will writing and LPOA services to people
					in the United Kingdom. Although we are not required to make a modern
					slavery statement under section 54 of the Modern Slavery Act 2015, we
					are making this voluntary statement to show our commitment to ethical
					trading principles and to set out the steps we are taking to tackle
					modern slavery and human trafficking in our business and in our supply
					chains.
				</p>
				<h3>2. Our Supply Chain</h3>
				<p>
					We are committed to ensuring that slavery or human trafficking do not
					take place in any part of our business or within our supply chains. We
					will not knowingly support or do business with any organisation that
					is involved in such practices and we would seek to terminate any
					relationship immediately where evidence of the same occurred.
				</p>
				<p>
					Our key suppliers are based in the United Kingdom and include funeral
					and legal service providers. Prior to any engagement with our
					suppliers, we ensure that they are a suitable organisation with which
					to do business.
				</p>
				<h3>3. Our Commitment To Ethical Trading</h3>
				<p>
					We are committed to acting ethically, working to the highest
					professional standards and complying with all applicable laws and
					regulations. We do not, and shall never, tolerate slavery and human
					trafficking and any other illegal or unethical conduct.
				</p>
				<h3>4. Training</h3>
				<p>
					To ensure a high level of understanding of the risks of modern slavery
					and human trafficking in our supply chains and our business, we
					provide training to our staff.
				</p>
				<h3>5. Further Steps</h3>
				<p>
					We will monitor the effectiveness of the measures that we are taking
					to ensure that there is no slavery or human trafficking in our
					business or our supply chain, including building upon and improving
					the policies that we have put in place. This statement was approved by
					the board of directors on the 12th of October 2024, signed by Chris
					Grix, our CEO on 13th of October 2023, and it is reviewed annually.
				</p>
			</section>
			<section>
				<h4>Contact</h4>
				<p>
					Questions, comments and requests regarding these policies are welcomed
					and should be addressed to{" "}
					<a href="mailto:pbraham@iamtheap.com">pbraham@iamtheap.com</a>
				</p>
				<p>These policies were last updated on 12 October 2023.</p>
			</section>
			<section>
				<h4 className="font-bold text-4xl mt-8">Cookie Policy</h4>
				<h4>What are cookies?</h4>
				<p>
					This Cookie Policy explains what cookies are and how we use them, the
					types of cookies we use i.e, the information we collect using cookies
					and how that information is used, and how to manage the cookie
					settings.
				</p>
				<p>
					Cookies are small text files that are used to store small pieces of
					information. They are stored on your device when the website is loaded
					on your browser. These cookies help us make the website function
					properly, make it more secure, provide better user experience, and
					understand how the website performs and to analyse what works and
					where it needs improvement.
				</p>
			</section>
			<section>
				<h4>How do we use cookies?</h4>
				<p>
					Like most online services, our website uses first-party and
					third-party cookies for several purposes. First-party cookies are
					mostly necessary for the website to function the right way, and they
					do not collect any of your personally identifiable data.
				</p>
				<p>
					The third-party cookies used on our website are mainly for
					understanding how the website performs, how you interact with our
					website, keeping our services secure, providing advertisements that
					are relevant to you, and all in all providing you with a better and
					improved user experience and help speed up your future interactions
					with our website.
				</p>
			</section>
			<section>
				<h4>Types of Cookies we use</h4>
				<h3>Necessary</h3>
				<p>
					Necessary cookies enable the basic features of this site, for example
					providing secure log-in, taking a payment or adjusting your consent
					preferences. They’re essential for making sure the site is working
					properly, so you cannot opt out of these.
				</p>
				<SiteTable
					headings={{
						cookie: "Cookie",
						duration: "Duration",
						description: "Description",
					}}
					cellData={[
						{
							cookie: "cookieyes-consent",
							duration: "1 year",
							description:
								"CookieYes sets this cookie to remember users’ consent preferences so that their preferences are respected on subsequent visits to this site. It does not collect or store any personal information about thesite visitors.",
						},
						{
							cookie: "_csrf",
							duration: "9 months 26 days",
							description:
								"This cookie is essential for the security of the website and visitor. It ensures visitor browsing security by preventing cross-site request forgery.",
						},
						{
							cookie: "willsReferralParams",
							duration: "3 months",
							description:
								"These cookies tell us if you have a voucher from one of our partners. It means we can discount the right amount from your will, without you having to remember a voucher code.",
						},
						{
							cookie: "farewill_account_session",
							duration: "1 day",
							description:
								"This cookie is used to authenticate you across our applications and is set when you log in to your account.",
						},
						{
							cookie: "__stripe_sid",
							duration: "1 hour",
							description:
								"Set for fraud prevention purposes and helps Stripe assess the risk associated with an attempted transaction.",
						},
						{
							cookie: "__stripe_mid",
							duration: "1 year",
							description:
								"Set for fraud prevention purposes and helps Stripe assess the risk associated with an attempted transaction.",
						},
						{
							cookie: "fwClientId",
							duration: "3 months",
							description:
								"This stores an anonymous, randomly generated identifier which we use to ensure you have a consistent experience across our sites.",
						},
					]}
				/>
				<h3>Functional</h3>
				<p>
					Functional cookies are used to recognise you when you return to our
					website. They enable us to personalise our content, greet you by name
					and remember your preferences.
				</p>
				<SiteTable
					headings={{
						cookie: "Cookie",
						duration: "Duration",
						description: "Description",
					}}
					cellData={[
						{
							cookie: "calltrk_referrer",
							duration: "3 months",
							description:
								"This is a functionality cookie set by the CallRail. This cookie is used to store the referring URL. It helps to accurately attribute the visitor source when displaying a tracking phone number.",
						},
						{
							cookie: "calltrk_landing",
							duration: "3header months",
							description:
								"This is a functionality cookie set by the CallRail. This cookie is used to store the landing page URL. It helps to accurately attribute the visitor source when displaying a tracking phone number.",
						},
						{
							cookie: "_hjAbsoluteSessionInProgress",
							duration: "30 minutes",
							description:
								"Hotjar sets this cookie to detect a user's first pageview session, which is a True/False flag set by the cookie.",
						},
					]}
				/>
				<h3>Analytics and performance</h3>
				<p>
					Analytical cookies are used to recognise and count the number of
					visitors to our site, and to see how visitors move around our website
					when they’re using it and before they call us. This helps us to
					improve the way our website works, for example, by ensuring our users
					find what they’re looking for easily.
				</p>
				<SiteTable
					headings={{
						cookie: "Cookie",
						duration: "Duration",
						description: "Description",
					}}
					cellData={[
						{
							cookie: "formattedFirstTouchTrackingParams",
							duration: "1 year",
							description:
								"These cookies store information about how you found Farewill when you first visited us. We use this to understand how people find us, and what brings them to Farewill.",
						},
						{
							cookie: "_hjIncludedInSessionSample_312514",
							duration: "2 minutes",
							description:
								"This is a cookie required for a third party site called Hotjar. We use Hotjar to help us understand how users behave on our website, and what information is most useful.",
						},
						{
							cookie: "cd_user_id",
							duration: "1 year",
							description:
								"This cookie is used for identifying the user session by storing unique ID for the users.",
						},
						{
							cookie: "_gcl_au",
							duration: "1 year 1 month 4 days",
							description:
								"Google Analytics sets this cookie to calculate visitor, session and campaign data and track site usage for the site's analytics report. The cookie stores information anonymously and assigns a randomly generated number to recognise unique visitors.",
						},
						{
							cookie: "_ga",
							duration: "1 year 1 month 4 days",
							description:
								"Google Analytics sets this cookie to calculate visitor, session and campaign data and track site usage for the site's analytics report. The cookie stores information anonymously and assigns a randomly generated number to recognise unique visitors.",
						},
						{
							cookie: "_gid",
							duration: "1 day",
							description:
								"Google Analytics sets this cookie to store information on how visitors use a website while also creating an analytics report of the website's performance. Some of the collected data includes the number of visitors, their source, and the pages they visit anonymously.",
						},

						{
							cookie: "_gat_UA-*",
							duration: "1 minute",
							description:
								"Google Analytics sets this cookie for user behaviour tracking.",
						},
						{
							cookie: "_gat_gtag_UA_*",
							duration: "1 minute",
							description:
								"Google Analytics sets this cookie to store a unique user ID.",
						},
						{
							cookie: "_hjFirstSeen",
							duration: "30 minutes",
							description:
								"Hotjar sets this cookie to identify a new user’s first session. It stores the true/false value, indicating whether it was the first time Hotjar saw this user.",
						},
						{
							cookie: "_ga_*",
							duration: "1 year 1 month 4 days",
							description:
								"Google Analytics sets this cookie to store and count page views.",
						},
						{
							cookie: "calltrk_session_id",
							duration: "3 months",
							description:
								"This cookie is set by the Provider CallRail. This cookie is used for storing an unique identifier for a user browser session. It is used for tracking the number of phone calls generate from the website.",
						},
						{
							cookie: "_fbp",
							duration: "3 months",
							description:
								"Facebook sets this cookie to display advertisements when either on Facebook or on a digital platform powered by Facebook advertising after visiting the website.",
						},
						{
							cookie: "_uetsid",
							duration: "1 day",
							description:
								"Bing Ads sets this cookie to engage with a user that has previously visited the website.",
						},

						{
							cookie: "_uetvid",
							duration: "1 year 24 days",
							description:
								"Bing Ads sets this cookie to engage with a user that has previously visited the website.",
						},
						{
							cookie: "calltrk_nearest_tld",
							duration: "1 year 1 month 4 days",
							description:
								"This cookie is required for a third party site called CallRail. If you call us, we’ll use CallRail to help us understand how you found Farewill.",
						},
						{
							cookie: "_gat_GA_APP_TRACKER",
							duration: "1 minute",
							description:
								"We need this cookie to use Google Analytics. This is a tool we use to understand how users behave on our website, so we can keep improving the experience.",
						},
						{
							cookie: "_gac_UA-64403748-5",
							duration: "3 months",
							description:
								"We need this cookie to use Google Analytics. This is a tool we use to understand how users behave on our website, so we can keep improving the experience.",
						},
						{
							cookie: "_opt_utmc",
							duration: "1 day",
							description:
								"Google Analytics sets this cookie to store information pertaining to the marketing campaign from which a user most recently came to the website.",
						},
						{
							cookie: "CONSENT",
							duration: "2 years",
							description:
								"YouTube sets this cookie via embedded YouTube videos and registers anonymous statistical data.",
						},
						{
							cookie: "formattedTrackingParams",
							duration: "3 months",
							description:
								"This stores information about how you found Farewill most recently. It’s another tool we use to help us provide a better experience.",
						},
						{
							cookie: "formattedTrackingParams",
							duration: "3 months",
							description:
								"This stores information about how you found Farewill most recently. It’s another tool we use to help us provide a better experience.",
						},
						{
							cookie: "_hjSessionUser_*",
							duration: "1 year",
							description:
								"Hotjar sets this cookie to ensure data from subsequent visits to the same site is attributed to the same user ID, which persists in the Hotjar User ID, which is unique to that site.",
						},
						{
							cookie: "_hjSession_*",
							duration: "30 minutes",
							description:
								"Hotjar sets this cookie to ensure data from subsequent visits to the same site is attributed to the same user ID, which persists in the Hotjar User ID, which is unique to that site.",
						},
						{
							cookie: "_hjRecordingLastActivity",
							duration: "never",
							description:
								"Hotjar sets this cookie when a user recording starts and when data is sent through the WebSocket.",
						},
						{
							cookie: "_hjRecordingEnabled",
							duration: "never",
							description:
								"Hotjar sets this cookie when a Recording starts and is read when the recording module is initialized, to see if the user is already in a recording in a particular session.",
						},
						{
							cookie: "bugsnag-anonymous-id",
							duration: "never",
							description:
								"BugSnag/Juicer sets this cookie for bug reporting and other analytical purposes.",
						},
					]}
				/>
			</section>
			<section>
				<h3>Targeting</h3>
				<p>
					Targeting cookies record your visit to our website, the pages you’ve
					visited and the links you’ve followed. They don’t store information
					that can directly identify you, but they can identify the browser and
					the device you’re using. We may share this information with third
					parties (such as the charities we work with) to make advertising
					displayed on other websites (such as Facebook) more relevant to you.
				</p>
				<SiteTable
					headings={{
						cookie: "Cookie",
						duration: "Duration",
						description: "Description",
					}}
					cellData={[
						{
							cookie: "MUID",
							duration: "1 year 24 days",
							description:
								"Bing sets this cookie to recognise unique web browsers visiting Microsoft sites. This cookie is used for advertising, site analytics, and other operations.",
						},
						{
							cookie: "test_cookie",
							duration: "15 minutes",
							description:
								"doubleclick.net sets this cookie to determine if the user's browser supports cookies.",
						},
						{
							cookie: "IDE",
							duration: "1 year 24 days",
							description:
								"Google DoubleClick IDE cookies store information about how the user uses the website to present them with relevant ads according to the user profile.",
						},
						{
							cookie: "_gcl_aw",
							duration: "3 months",
							description:
								"DoubleClick sets this cookie to understand user interaction with the site and advertising.",
						},
						{
							cookie: "YSC",
							duration: "session",
							description:
								"Youtube sets this cookie to track the views of embedded videos on Youtube pages.",
						},
						{
							cookie: "VISITOR_INFO1_LIVE",
							duration: "5 months 27 days",
							description:
								"YouTube sets this cookie to measure bandwidth, determining whether the user gets the new or old player interface.",
						},
						{
							cookie: "yt-remote-device-id",
							duration: "never",
							description:
								"YouTube sets this cookie to store the user's video preferences using embedded YouTube videos.",
						},
						{
							cookie: "yt.innertube::requests",
							duration: "never",
							description:
								"YouTube sets this cookie to register a unique ID to store data on what videos from YouTube the user has seen.",
						},
						{
							cookie: "yt.innertube::nextId",
							duration: "never",
							description:
								"YouTube sets this cookie to register a unique ID to store data on what videos from YouTube the user has seen.",
						},
						{
							cookie: "yt-remote-connected-devices",
							duration: "never",
							description:
								"YouTube sets this cookie to store the user's video preferences using embedded YouTube videos.",
						},
					]}
				/>
			</section>
			<section>
				<h4 className="font-bold text-4xl mt-8">Manage cookie preferences</h4>
				<p>
					<a
						href="https://farewill.com/cookies"
						target="_blank"
						rel="noreferrer"
					>
						Cookie Settings
					</a>
				</p>
				<p>
					You can change your cookie preferences any time by clicking the above
					button. This will let you revisit the cookie consent banner and change
					your preferences or withdraw your consent right away.
				</p>
				<p>
					In addition to this, different browsers provide different methods to
					block and delete cookies used by websites. You can change the settings
					of your browser to block/delete the cookies. Please see the links to
					support documents detailing how to manage and delete cookies from the
					major web browsers.
				</p>
				<p>
					<a
						href="https://support.google.com/accounts/answer/32050"
						target="_blank"
						rel="noreferrer"
					>
						Chrome
					</a>
				</p>
				<p>
					<a
						href="https://support.apple.com/en-in/guide/safari/sfri11471/mac"
						target="_blank"
						rel="noreferrer"
					>
						Safari
					</a>
				</p>
				<p>
					<a
						href="https://support.mozilla.org/en-US/kb/clear-cookies-and-site-data-firefox?redirectslug=delete-cookies-remove-info-websites-stored&redirectlocale=en-US"
						target="_blank"
						rel="noreferrer"
					>
						Firefox
					</a>
				</p>
				<p>
					<a
						href="https://support.microsoft.com/en-us/microsoft-edge/delete-cookies-in-microsoft-edge-63947406-40ac-c3b8-57b9-2a946a29ae09"
						target="_blank"
						rel="noreferrer"
					>
						Microsoft Edge
					</a>
				</p>
				<p>
					If you are using any other web browser, please visit your browser’s
					official support documentation.
				</p>
			</section>
			<section>
				<h4 className="font-bold text-4xl mt-8">Do Not Track</h4>
				<p>
					We use your &apos;Do Not Track&apos; status to decide whether to turn
					on tracking scripts such as affiliates, Facebook, Google Analytics and
					Hotjar.
				</p>
				<p>
					Most browsers let you turn on &apos;Do Not Track&apos;.{" "}
					<a href="https://allaboutdnt.com/" target="_blank" rel="noreferrer">
						Learn how to turn on &apos;Do Not Track&apos; in your browser.
					</a>
				</p>
			</section>
		</div>
	</div>
);

export default withPage(PrivacyPolicy);
